import SingleBannerPage from './SingleBanner-Container';
export default SingleBannerPage;
